import { IPage } from 'utils/data/sectionList'
import { RootState } from 'modules'

export const selectSidebarMenu = (state: RootState): Array<IPage> | null =>
  state.sidebarMenu
